<template>
  <div class="content">
    <ShortVideo
      v-if="shortVideo.length"
      :short-video="shortVideo"
      :get-uigs="getShortVideoUigs"
      :get-uigs-play-info="getShortVideoPlayInfo"
      :show-loading="!loadingFinished"
    />
    <NoResult v-else />
    <Gotop />
    <div
      v-if="isSnapShot"
      class="snap-shot-query"
    >
      {{ query }}
    </div>
  </div>
</template>

<script>
import { throttle  } from '@asset/js/util';
import * as types from '@types';
import { mapActions, mapMutations, mapState } from 'vuex';

import Gotop from '../../common/components/Gotop.vue';
import NoResult from './NoResult.vue';
import ShortVideo from './ShortVideo.vue';

const { init } = require('../../common/js/searchNav');
const { getScrollParams } = require('../../common/js/util');
// 最大展现条数
const MAX_ITEM_NUM = 100;

export default {
  components: {
    ShortVideo,
    NoResult,
    Gotop,
  },
  props: {
    getDocInfo: {
      type: Function,
      default: () => null,
    },
    getShortVideoPlayInfo: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('common', ['$config', 'loadingFinished']),
    ...mapState('search', ['shortVideo', 'query', 'maxEnd']),
    isSnapShot() {
      return (this.$config || {}).hitSnapshot === '1';
    },
  },
  mounted() {
    // 搜索框头部初始化
    const { spver = '' } = this.$route.query;
    init(spver);

    // 初始化sugg
    require('../../common/js/searchSugg');
    this.getDocument('input.hhy-input') && (this.getDocument('input.hhy-input').value = this.query);
    this.getDocument('.hhy-del') && (this.getDocument('.hhy-del').style.display = 'block');

    this.handleSearchRecords();
    this.initScrollLoad();

    const { approveToken } = this.$config || {};
    // 搜索pv日志上报
    this.$uigs.send({ ...window.UIGS_PARA, isApprove: approveToken ? 1 : 0 });

    // 增加命中kd实验参数
    this.initKDExp();
  },
  beforeDestroy() {
    if (typeof this.handleScrollLoad === 'function') {
      window.removeEventListener('scroll', this.handleScrollLoad);
    }
  },
  methods: {
    ...mapMutations('common', [types.UPDATE_LOADING_FINISHED]),
    ...mapActions('search', ['getNextPageData']),
    handleSearchRecords() {
      if (window.location.href.indexOf('w=06009900') !== -1) {
        try {
          const { query } = this;
          if (query.length < 38) {
            let searchRecords = localStorage.getItem('v_search_record');
            if (searchRecords && searchRecords.length > 0) {
              searchRecords = JSON.parse(searchRecords);
              if (Array.isArray(searchRecords)) {
                const curIndex = searchRecords.indexOf(query);
                if (curIndex > -1) {
                  searchRecords.splice(curIndex, 1);
                }
                if (searchRecords.length === 10) {
                  searchRecords.pop();
                }
                searchRecords.unshift(query);
              }
            } else {
              searchRecords = [];
              searchRecords.unshift(query);
            }
            localStorage.setItem('v_search_record', JSON.stringify(searchRecords));
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    initScrollLoad() {
      // 滚动加载
      this.handleScrollLoad = throttle(async () => {
        const html = document.documentElement;
        const { body } = document;
        const winH = window.innerHeight;
        const scrollH = Math.max(html.scrollHeight, body.scrollHeight);
        const scrollTop = html.scrollTop || body.scrollTop;
        const shortLength = this.shortVideo ? this.shortVideo.length : 0;
        if (shortLength >= Math.min(this.maxEnd, MAX_ITEM_NUM)) {
          this[types.UPDATE_LOADING_FINISHED](true);
        }
        if (
          !this.loading
          && !this.loadingFinished
          && scrollH - winH > scrollTop - 50
          && scrollH - winH < scrollTop + 50
        ) {
          this.loading = true;
          await this.getNextPageData({
            params: this.$route.query,
            callback: (res) => {
              this.loading = false;
              // 滚动pblet
              const opts = getScrollParams({
                scrollParams: JSON.stringify({
                  addition: 'video',
                  pn: Math.ceil(this.shortVideo.length / 10),
                }),
              });
              opts.suuid = res && res.data && res.data.uuid;
              this.$uigs.send(opts);
            },
            failed: (err) => {
              this.loading = false;
              console.log(err);
            },
          });
        }
      }, 500);
      window.addEventListener('scroll', this.handleScrollLoad);
    },
    initKDExp() {
      const $hitKdInput = document.createElement('input');
      const $searchbox = document.querySelector('form.hhy-searchbox');
      $hitKdInput.type = 'hidden';
      $hitKdInput.name = 'isHitKd';
      $hitKdInput.value = this.$config.isHitKd === '1' ? 1 : 0;
      $searchbox && $searchbox.appendChild($hitKdInput);
    },
    getShortVideoUigs({ item, index }) {
      let str = '';
      if (item.posName) {
        str = `${item.posName}_${item.location}_${item.id}_${item.title}`;
      } else {
        str = `out_list_video_${index}|${item.docid}|${item.itemUrl}`;
      }
      return str;
    },
    getDocument(name) {
      return document.querySelector(name);
    },
  },
};
</script>

<style lang="scss">
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background: none;
  text-decoration: none;
}
h3 > em {
  color: #f5490a;
}
.content {
  overflow: hidden;
}
.hhy-suggestion .hhy-sugglist p {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
}
.snap-shot-query {
  position: fixed;
  z-index: 100;
  top: 62px;
  left: 30px;
  font-size: 18px;
}
</style>
